/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbSharedContentModuleBanner_browseContentModule$ref = any;
export type SbSharedContentModuleBanner_browseContentModule = {
    readonly photo: string | null;
    readonly title: string | null;
    readonly subtitle: string | null;
    readonly description: string | null;
    readonly link: string | null;
    readonly linkText: string | null;
    readonly " $refType": SbSharedContentModuleBanner_browseContentModule$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedContentModuleBanner_browseContentModule",
    "type": "ContentModuleBanner",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "photo",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "subtitle",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "description",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "link",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "linkText",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = '721f11291a4c2bda1bf806b3ed653b1b';
export default node;
